export default "__VITE_ASSET__D2EInp30__"